<div class="toast-line" [ngClass]="{'toast-line-web': factorySer.isWebStyle}"
    [ngStyle]="{'margin-bottom': marginBtm? marginBtm : '2rem', 'display': showToast? 'flex':'none'}">
    <div class="toast-box">
        <i #icon class="toast-icon"></i>
        <span class="toast-txt font14-reg">{{ text | acpText }}</span>
    </div>
</div>
<!-- 预加载icon -->
<i class="fail" aria-hidden="true"></i>
<i class="warning" aria-hidden="true"></i>
<i class="success" aria-hidden="true"></i>